/**
 * @fileoverview Bridge PrimeReact chips to the application's managed icon vocabulary through `AppIcon.js`. Chip data, selection, and removal semantics belong to consuming workspaces; the adapter preserves the third-party control's interaction contract.
 */

import React from 'react'
import { Chip as PrimeChip } from 'primereact/chip'
import AppIcon from './AppIcon'



function resolveChipIcon(icon) {
    if (!icon || React.isValidElement(icon)) {
        return icon
    }

    if (typeof icon === 'string') {
        return ({ iconProps }) => <AppIcon {...iconProps} icon={icon} />
    }

    return icon
}



function AppPrimeChip({ icon, ...rest }) {
    return (
        <PrimeChip
            {...rest}
            icon={resolveChipIcon(icon)}
        />
    )
}

export default AppPrimeChip
